import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchConnectorFamiliesResponse, UpdateConnectorFamilyBody } from "./types/connectorFamilies";

export const useDeckConnectorFamiliesApi = () => {
  const crud = createAdminCrudApi<SearchConnectorFamiliesResponse, never, UpdateConnectorFamilyBody>(
    useApi(),
    DECK_ADMIN_URL,
    "connector_families",
  );

  return {
    useDeckConnectorFamilies: crud.useSearch,
    getDeckConnectorFamilies: crud.search,
    updateDeckConnectorFamily: crud.update,
    updateDeckConnectorFamilyVisibility: crud.updateVisibility,
    updateDeckConnectorFamilyOrder: crud.updateOrder,
  };
};

export default useDeckConnectorFamiliesApi;
